import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const AdvancingTemplatePaginatedDropdown = (props: DropdownWithoutOptionsProps<server.dto.AdvancingTemplateSmall>) => {
  const fetchAdvancingTemplate = async (search: string, page: number) => {
    const res = await window.CoreApi.AdvancingTemplate.Paginated({
      keyword: search,
      page,
      perPage: 10
    });

    return res;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}
    fetchOptions={fetchAdvancingTemplate}
    getLabel={a => a.name}
    getValue={a => a.advancingTemplateId}
    config={props.config}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default AdvancingTemplatePaginatedDropdown;